import { OTHER } from '../../../../../constants';

export const compareIndustries = ([industryKey1, industryValue1], [industryKey2, industryValue2]) => {
    if (industryKey1 === OTHER) {
        return 1;
    }
    if (industryKey2 === OTHER) {
        return -1;
    }
    return industryValue2 - industryValue1;
};
